import axios from "axios";

var token = localStorage.getItem("token")
  ? "Token " + localStorage.getItem("token")
  : "";
// export default axios.create({
//   // baseURL: `http://jsonplaceholder.typicode.com/`
//   baseURL: `http://127.0.0.1:8000/`,
//   headers: {'Authorization': token}
// });

const axiosInstance = axios.create();

// axiosInstance.defaults.baseURL = 'https://licbangladesh.com/licadmin/api/';
// axiosInstance.defaults.baseURL = "https://licbangladesh.com/licadmin/api/";
axiosInstance.defaults.baseURL = process.env.REACT_APP_BACKEND_URL +"/api/";
// axiosInstance.defaults.baseURL = 'https://licbangladesh.com/licadmin/';
// axiosInstance.defaults.baseURL = 'http://192.168.10.82:8090/api/';
// axiosInstance.defaults.baseURL = 'http://192.168.10.82:8000/api/';
// axiosInstance.defaults.baseURL = 'http://192.168.10.81:3333/api/';
// axiosInstance.defaults.baseURL = 'http://192.168.10.101:3333/api/';
//axiosInstance.defaults.baseURL = "http://202.126.123.157:8686/api/";
//axiosInstance.defaults.baseURL = 'http://127.0.0.1:3333/api/';
//axiosInstance.defaults.baseURL = `http://licadmin.com:8080/api/`;

export const axiosNewInstance = axios.create();
// axiosNewInstance.defaults.baseURL = "https://licbangladesh.com/licadmin/";
// axiosNewInstance.defaults.baseURL = "https://licbangladesh.com/licadmin/";
axiosNewInstance.defaults.baseURL = process.env.REACT_APP_BACKEND_URL + "/";
// axiosNewInstance.defaults.baseURL = "http://202.126.120.114:8585/lic2/licadmin/"; // --- for testing
// export const axiosNewVersionInstance = axios.create();
// axiosNewVersionInstance.defaults.baseURL = "https://licbangladesh.com/licadmin/";

const handleUnauthorizedResponse = (error) => {
  if (
    error.response &&
    (error.response.status === 401 ||
      (error.response.data?.status === 0 &&
        String(error.response.data?.message || "").toLowerCase().includes("unauthenticated")))
  ) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user_name");
    localStorage.removeItem("activeItem");

    const currentPath = window.location.pathname;
    if (
      !currentPath.includes("/login") &&
      !currentPath.includes("/register") &&
      !currentPath.includes("/forgot-pass")
    ) {
      window.location.href = `/login-office?redirect=${encodeURIComponent(currentPath)}`;
    }
  }
  return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
  (response) => response,
  handleUnauthorizedResponse
);

axiosNewInstance.interceptors.response.use(
  (response) => response,
  handleUnauthorizedResponse
);

export const casInstance = axios.create();
casInstance.defaults.baseURL = "https://api.icab.org.bd/api/";
export const caversion = "v1/";
casInstance.defaults.headers.common["Authorization"] =
  "Basic Y2xpZW50LXdlYjpVQTAxMjM0NTY=";

// axiosInstance.defaults.headers.common['Authorization'] = token;
// axiosInstance.defaults.headers.common['User-ID'] = '';

export const version = "v1/";
export const imagePath = "v1/";

export const processMaker = axios.create();
processMaker.defaults.baseURL =
  "https://studentservices.icab.org.bd/sysworkflow/en/neoclassic/services/soap2";
processMaker.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// export const image_url = "https://licbangladesh.com/licadmin/";
export const image_url = process.env.REACT_APP_BACKEND_URL + "/";
//export const image_url = `http://licadmin.com:8080/`;

// export const base_path = "/";
// export const base_path = "https://licbangladesh.com/licadmin/";  //it's important for production route ---------------------
export const base_path = ""; //it's important for development route ---------------------
//export const base_path = 'https://licbangladesh.com/dynamic/';
//export const host_name = 'https://licbangladesh.com/dynamic/';
// export const host_name = "https://licbangladesh.com/";
export const host_name = "http://localhost:3000/";
//export const host_name = `http://licbangladesh.lic:8080/`;

export const encryption_salt = "LIC@2022";
export const google_recaptcha_site_key =
  "6Le2E5gaAAAAADPCWtOtzWkaBwQ1jAlPtjP7XRuK";

export default axiosInstance;

export const axiosPorichoy = axios.create();
axiosPorichoy.defaults.baseURL = "https://api.porichoybd.com/api/kyc/";
// axiosPorichoy.defaults.baseURL = 'https://api.porichoybd.com/sandbox-api/';
axiosPorichoy.defaults.headers.common["x-api-key"] =
  "92673172-a9e7-4d92-9324-5f3821927fb0";
axiosPorichoy.defaults.headers.common["Content-Type"] = "application/json";
